import { mainTransition } from '../../../../utils/Styles';

export const mainGridStyles = {
  display: 'none',
  position: 'absolute',
  top: -37,
  transition: `all ${mainTransition}`,
};
